"use client";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as e, jsxs as l } from "react/jsx-runtime";
import { useTheme as h } from "../../hooks.js";
import { useIsInverseVariant as s } from "../../theme-variant-context.js";
import { vars as a } from "../../skins/skin-contract.css-mistica.js";
const d = (_param)=>{
    var { color: n, size: t = 24 } = _param, r = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    const c = s(), o = n !== null && n !== void 0 ? n : c ? a.colors.inverse : a.colors.neutralHigh, { skinName: i } = h();
    return i.match(/^vivo-new/i) ? /* @__PURE__ */ e("svg", _object_spread_props(_object_spread({
        width: t,
        height: t,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, r), {
        children: /* @__PURE__ */ e("path", {
            fill: o,
            d: "M12 1.375c.345 0 .625.28.625.625v10a.625.625 0 1 1-1.25 0V2c0-.345.28-.625.625-.625M6.072 6.198a.625.625 0 0 1 0 .884 8.375 8.375 0 1 0 11.846 0 .625.625 0 1 1 .884-.884 9.625 9.625 0 1 1-13.614 0 .625.625 0 0 1 .884 0"
        })
    })) : i.match(/^o2-new/i) ? /* @__PURE__ */ l("svg", _object_spread_props(_object_spread({
        width: t,
        height: t,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, r), {
        children: [
            /* @__PURE__ */ e("path", {
                fill: o,
                d: "M11.215 12.668c0 .416.35.761.777.761a.773.773 0 0 0 .776-.761V2.762A.773.773 0 0 0 11.992 2a.773.773 0 0 0-.777.762z"
            }),
            /* @__PURE__ */ e("path", {
                fill: o,
                d: "M2.47 12.668C2.47 17.81 6.749 22 11.992 22c5.247 0 9.522-4.193 9.526-9.332 0-4.037-2.645-7.621-6.57-8.876-.388-.116-.857.112-.973.493-.115.38.116.842.504.954 3.268 1.066 5.482 4.037 5.482 7.429 0 4.305-3.575 7.809-7.97 7.809-4.393 0-7.968-3.504-7.968-7.81 0-3.391 2.218-6.366 5.486-7.428.426-.116.618-.573.503-.954-.115-.417-.584-.605-.972-.493-3.93 1.255-6.57 4.835-6.57 8.876"
            })
        ]
    })) : i.match(/^o2/i) ? /* @__PURE__ */ l("svg", _object_spread_props(_object_spread({
        width: t,
        height: t,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, r), {
        children: [
            /* @__PURE__ */ e("path", {
                fill: o,
                d: "M11.215 12.668c0 .416.35.761.777.761a.773.773 0 0 0 .776-.761V2.762A.773.773 0 0 0 11.992 2a.773.773 0 0 0-.777.762z"
            }),
            /* @__PURE__ */ e("path", {
                fill: o,
                d: "M2.47 12.668C2.47 17.81 6.749 22 11.992 22c5.247 0 9.522-4.193 9.526-9.332 0-4.037-2.645-7.621-6.57-8.876-.388-.116-.857.112-.973.493-.115.38.116.842.504.954 3.268 1.066 5.482 4.037 5.482 7.429 0 4.305-3.575 7.809-7.97 7.809-4.393 0-7.968-3.504-7.968-7.81 0-3.391 2.218-6.366 5.486-7.428.426-.116.618-.573.503-.954-.115-.417-.584-.605-.972-.493-3.93 1.255-6.57 4.835-6.57 8.876"
            })
        ]
    })) : /* @__PURE__ */ l("svg", _object_spread_props(_object_spread({
        width: t,
        height: t,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, r), {
        children: [
            /* @__PURE__ */ e("path", {
                fill: o,
                d: "M12.077 18.097c-1.919 0-3.417-.507-4.454-1.507-1.075-1.037-1.622-2.577-1.622-4.572 0-1.658.379-3.005 1.126-4.008.737-.989 1.821-1.633 3.219-1.91a.559.559 0 1 1 .219 1.098c-2.32.462-3.446 2.039-3.446 4.82 0 1.681.431 2.947 1.28 3.765.82.79 2.059 1.19 3.678 1.19 1.62 0 2.857-.4 3.678-1.193.849-.818 1.28-2.084 1.28-3.764 0-2.821-1.16-4.404-3.543-4.84a.56.56 0 1 1 .201-1.104c1.435.263 2.544.899 3.303 1.89.77 1.009 1.16 2.37 1.16 4.05 0 1.995-.547 3.536-1.625 4.572-1.037 1.006-2.535 1.513-4.454 1.513"
            }),
            /* @__PURE__ */ e("path", {
                fill: o,
                d: "M11.489 8.985c0 .308.252.56.56.56s.56-.252.56-.56V4.887a.56.56 0 0 0-.56-.56.56.56 0 0 0-.56.56z"
            }),
            /* @__PURE__ */ e("path", {
                fill: o,
                d: "M4.763 19.425c1.673 1.61 4.107 2.428 7.236 2.428s5.563-.815 7.238-2.426c1.736-1.672 2.616-4.17 2.616-7.423 0-3.255-.88-5.75-2.616-7.425-1.675-1.611-4.11-2.429-7.238-2.429-3.13 0-5.563.818-7.236 2.426C3.03 6.25 2.15 8.749 2.15 12.002c0 3.255.88 5.75 2.613 7.422m-1.523-7.42c0-5.816 2.946-8.765 8.759-8.765 5.815 0 8.762 2.95 8.764 8.764 0 5.813-2.95 8.76-8.764 8.76s-8.76-2.947-8.76-8.76"
            })
        ]
    }));
}, w = d;
export { w as default };
